"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultExclusiveTranslateState = void 0;
exports.defaultExclusiveTranslateState = {
    bannerTitle: 'Our Exclusives',
    bannerCaption: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    soleAgentCountCaption: 'Total Number Of Sole Agents',
    soleAgentForSaleCaption: 'Sole Agents For Sale',
    soleAgentForRentCaption: 'Sole Agents For Rent',
    searchInputPlaceholder: 'Enter Keyword / District / Street / Address/ Building',
    searchInputSmPlaceholder: 'Enter Keyword',
    searchPrice: 'Price',
    searchMinPrice: 'Min Price',
    searchMaxPrice: 'Max Price',
    searchForAll: 'All',
    searchForSale: 'For Sale',
    searchForRent: 'For Rent',
    moreProperties: 'More Properties',
    cardLabelSoleAgent: 'Sole Agent',
    cardLabelJointSoleAgent: 'Joint Sole Agent',
    cardPricePrefix: 'HK$',
    cardPriceSTO: 'Subject To Offer',
    cardPopupSizeUnitNet: 'SF (S)',
    cardPopupSizeUnitGross: 'SF (G)',
    cardPopupBeds: 'Beds',
    cardPopupBaths: 'Baths',
    cardPopupMore: 'More Info.',
    cardInc: 'incl.',
    cardExcl: 'excl.',
    sortBestMatch: 'Best Match',
    sortPriceLowToHigh: 'Price (Low to High)',
    sortPriceHighToLow: 'Price (High to Low)',
    sortPricePerSqftLowToHigh: 'Price per sq.ft. (Low to High)',
    sortPricePerSqftHighToLow: 'Price per sq.ft. (High to Low)',
    sortSizeLargeToSmall: 'Size (Large to Small)',
    sortSizeSmallToLarge: 'Size (Small to Large)',
    sortDistrictAZ: 'District Name (A-Z)',
    sortDistrictZA: 'District Name (Z-A)',
    sortBuildingAZ: 'Building Name (A-Z)',
    sortBuildingZA: 'Building Name (Z-A)',
    sortLastUpdated: 'Last Updated',
    searchUnitMillion: 'M',
    searchUnitThousand: 'K',
    searchUnitTenThousand: '萬',
    apply: 'Apply',
    buildings: 'Buildings',
    districts: 'Districts',
    estates: 'Estates',
    phases: 'Phases',
    roads: 'Roads',
    noResultTitle: 'No Results',
    noResultCaptionRent: 'No properties match this search criteria. Click <a class="c-exclusivesearch__hint-link" target="_blank" href="/en/property-search/rent">here</a> to expand your search to all listings at OKAY.com 屋企',
    noResultCaptionSale: 'No properties match this search criteria. Click <a class="c-exclusivesearch__hint-link" target="_blank" href="/en/property-search/buy">here</a> to expand your search to all listings at OKAY.com 屋企',
};
